const tinycolor = require('tinycolor2');
export const isLight = (color) => tinycolor(color).isLight();
export const isDark = (color) => tinycolor(color).isDark();
export const toHex = (color) => tinycolor(color).toHexString();
export const toRgb = (color) => tinycolor(color).toRgbString();
export const rgbToHex = toHex;
export const hexToRgb = toRgb;
//# sourceMappingURL=color-utils.js.map